export default __webpack_public_path__ + "static/7sarkany-9d3928ee3fada92c610b3251833d000e.png";